<script>
export default {
  name:'dol-tree',
  props: {
    source: { type: String, default: 'server' },            //数据源，server | local
    //---------------------- if source === server --------------------------------//
    url: { type: String },                                  //后台地址
    method: { type: String, default: 'get' },              //请求方式
    queryData: { type: Object, default: function(){return {};} },             //请求参数
    queryParams: { type: Object, default: function(){return {};} },             //请求参数
    queryPathData: { type: Object, default: function(){return {};} },             //请求参数
    initDataFlag: { type: Boolean, default: true },         //默认是否请求一次数据
    //---------------------- if source === local  --------------------------------//
    defaultData: { type: Array, default: function(){return [];} },                     //后台地址

    nameField: { type: String, default: 'name' },                     //label字段
    keyField: { type: String, default: '_id' },                     //key字段
    expandedKeys: { type: Array, default: () => [] },                     //后台地址
    filterFlag: { type: Boolean, default: true },                     //后台地址
    title: {type: String, default: '树'},
    titleFlag: {type: Boolean, default: true},
    cardFlag: {type: Boolean, default: true},
    defaultExpandAll: {type: Boolean, default: false},

    asyncFlag: {type: Boolean, default: false},
    rootId: {type: String, default: null},

    checkable: {type: Boolean, default: false},
    checkStrictly: {type: Boolean, default: false},
    value: {type: Array},
  },
  data:function () {
    let params = {
      serverData: [],
      filterExpandedKeys: [],
      loadingFlag: false,
    };
    return params;
  },
  computed:{
    treeData(){
      let data = [];
      switch (this.source) {
        case 'server':
          data = this.serverData;
          break;
        case 'local':
          data = this.defaultData;
          break;
      }
      return data;
    },
    treeExpandedKeys(){
      if(this.filterFlag){
        return this.filterExpandedKeys;
      }else{
        return this.expandedKeys;
      }
    },
  },
  methods:{
    query: function () {
      if(this.source === 'server'){
        this.loadingFlag = true;
        let params = {...this.queryParams};
        let data = {...this.queryData};
        if(this.asyncFlag){
          if(this.rootId){
            data._id = this.rootId;
          }else{
            data.parent = null;
          }
        }
        this.$ajax({
          url: this.url,
          method:this.method,
          params,
          data,
          pathData: this.queryPathData,
        }).then((data) => {
          this.loadingFlag = false;
          this.serverData = data.rows;
        }).catch(() => {
          this.loadingFlag = false;
        });
      }
    },
    asyncLoadData(treeNode){
      if(treeNode.children){
        return Promise.resolve();
      }else{
        return this.$ajax({
          url: this.url,
          method:this.method,
          params: this.queryParams,
          data: {parent: treeNode.dataRef._id, ...this.queryData},
          pathData: this.queryPathData,
        }).then(({rows}) => {
          treeNode.dataRef.children = rows;
          this.serverData = [...this.serverData];
        });
      }
    },
    filter(value){
      let expandedKeys = [];
      if(value){
        let find = (data) => {
          data.forEach(d => {
            if(d.children && d.children.length > 0){
              find(d.children);
            }
            if(d.parent && new RegExp(value).test(d.name)){
              expandedKeys.push(d.parent._id);
            }
          });
        };
        find(this.treeData);
      }
      this.filterExpandedKeys = expandedKeys;
    },
    select(selectedKeys, e){
      this.$emit('select', selectedKeys, e);
    },
    expand(expandedKeys, {expanded, node}){
      this.filterExpandedKeys = expandedKeys;
      this.$emit('expand', expandedKeys, {expanded, node});
    },
    check(checkedKeys, {checked, checkedNodes, node, event}){
      if(this.checkStrictly){
        this.$emit('input', checkedKeys.checked, {checked, checkedNodes, node, event});
      }else{
        this.$emit('input', checkedKeys, {checked, checkedNodes, node, event});
      }
    },
  },

  created: function () {
    if(this.source === 'server'){
      if(this.initDataFlag){
        this.query();
      }
    }
  },
  render(createElement){
    let createNode = (data, level, parent) => {
      let children = [];
      data && data.forEach(node => {
        let renderNode;
        if(typeof this.$scopedSlots.default === 'function'){
          renderNode = createElement('span', {slot: 'title'}, this.$scopedSlots.default({node: node, level: level, $parent: parent}));
        }else if(this.$slots.default){
          renderNode = createElement('span', {slot: 'title'}, this.$slots.default);
        }else{
          renderNode = createElement('span', {slot: 'title'}, node[this.nameField]);
        }

        children.push(createElement('a-tree-node', {
          props: node,
          key: node[this.keyField],
        }, [
          renderNode,
          ...createNode(node.children, level+1, node),
        ]))
      });
      return children;
    };

    let treeProps = {
      defaultExpandAll: this.defaultExpandAll,
      expandedKeys: this.treeExpandedKeys,
      checkable: this.checkable,
      checkedKeys: this.value,
      checkStrictly: this.checkStrictly,
    }
    if(this.asyncFlag){
      treeProps.loadData = this.asyncLoadData;
      treeProps.treeData = this.treeData;
      treeProps.replaceFields = {title: this.nameField, key: this.keyField};
    }

    return createElement('dol-card', {
      props:{
        cardFlag: this.cardFlag,
        titleFlag: this.titleFlag,
        title: this.title,
      },
    }, [
      createElement('template', {slot: 'extra'}, this.$slots.extra),
      createElement('template', {slot: 'queryForm'}, this.$slots.queryForm),
      createElement('a-tree', {
        on:{
          select: this.select,
          expand: this.expand,
          check: this.check,
        },
        props: treeProps,
      }, createNode(this.treeData)),
    ]);
  }
}
</script>

<style lang="scss">
div.dolphin-tree{
  position: relative;
}
</style>
